import { useContext } from 'react'
import { AppConfigContext } from '@/root/shared-providers'

import type { AppConfigContextType } from '@/root/shared-providers/AppConfigProvider/AppConfigContext'

export const useAppConfig = (): AppConfigContextType => {
  return useContext(AppConfigContext) as AppConfigContextType
}
